export const RecurringPlanUtility = {
    allowedOperations(paymentPlan) {
        const operations = [];

        const openAmount = paymentPlan?.totalDueAmount || 0;
        const status = paymentPlan?.status;
        const invoiceId = paymentPlan?.invoiceId;
        const invoiceStatus = paymentPlan?.invoiceStatus;
        const transactionType = paymentPlan?.transactionType;

        // Show status title
        if (status != null) {
            operations.push(RecurringOperation.STATUS_TITLE);
        }

        // Allow update if not in terminal statuses and paymentPlan status is not Cancelled or failed or Completed or closed or paused
        if (![4, 8, 5, 3, 30].includes(status)) {
            operations.push(RecurringOperation.UPDATE_PLAN);
        }

        // Always allow preview
        operations.push(RecurringOperation.VIEW_DETAILS);

        // Allow cancel if certain invoice statuses and invoiceId is present
        if (
            invoiceId &&
            (
                [
                    InvoiceStatus.Draft,
                    InvoiceStatus.Finalize,
                    InvoiceStatus.PaymentPlanCreated,
                    InvoiceStatus.OneTimeScheduledCreated,
                    InvoiceStatus.SubscriptionPlanCreated,
                ].includes(invoiceStatus) ||
                (
                    transactionType !== InvoiceType.Installment &&
                    [InvoiceStatus.InProgress, InvoiceStatus.Unpaid].includes(invoiceStatus)
                )
            ) &&
            openAmount > 0
        ) {
            operations.push(RecurringOperation.CANCEL);
        }

        // Allow Pause if Subscription plan
        if (
            invoiceId &&
            (
                (
                    transactionType == InvoiceType.Subscription &&
                    [InvoiceStatus.InProgress].includes(invoiceStatus) &&
                    status !== paymentPlanStatus.find(s => s.title === 'Paused').value
                )
            ) &&
            openAmount > 0
        ) {
            operations.push(RecurringOperation.PAUSE);
        }
        
        // Allow RESTART if Subscription plan
        if (
            invoiceId &&
            (
                (
                    transactionType == InvoiceType.Subscription &&
                    [InvoiceStatus.InProgress].includes(invoiceStatus) &&
                    status == paymentPlanStatus.find(s => s.title === 'Paused').value
                )
            ) &&
            openAmount > 0
        ) {
            operations.push(RecurringOperation.RESTART);
        }

        // Allow cancel and write-off if installment and status is unpaid/in-progress
        if (
            invoiceId &&
            transactionType === InvoiceType.Installment &&
            [InvoiceStatus.Unpaid, InvoiceStatus.InProgress].includes(invoiceStatus)
        ) {
            operations.push(RecurringOperation.CLOSE_WRITE_OFF);
        }

        return operations;
    },

    OperationAllowed(paymentPlan, operation) {
        const allowed = this.allowedOperations(paymentPlan);
        return allowed.includes(operation);
    },

    GetStatusTitle(status) {
        const mapping = new Map(paymentPlanStatus.map(obj => [obj.value, obj.title]));
        return mapping.get(status) || 'Unknown';
    }
};

export const RecurringOperation = {
    STATUS_TITLE: 1,
    UPDATE_PLAN: 2,
    VIEW_DETAILS: 3,
    CANCEL: 4,
    CLOSE_WRITE_OFF: 5,
    PAUSE: 6,
    RESTART: 7
};

export const paymentPlanStatus = [
    { title: 'Active', value: 2 },
    { title: 'Created', value: 1 },
    { title: 'Completed', value: 3 },
    { title: 'Paused', value: 4 },
    { title: 'Cancelled', value: 8 },
    { title: 'Failed', value: 5 },
    { title: 'Closed', value: 30 }
];

export const InvoiceStatus = {
    Draft: 1,
    Finalize: 2,
    Cancelled: 3,
    PaymentInitiated: 4,
    PaymentPlanCreated: 5,
    OneTimeScheduledCreated: 6,
    SubscriptionPlanCreated: 7,
    InProgress: 8,
    Paid: 9,
    Unpaid: 10,
    Unsubscribed: 11,
    Closed: 30,
};

export const InvoiceType = {
    OneTime: 0,
    Installment: 1,
    ScheduledOneTime: 2,
    Subscription: 3,
    PartialPay: 4,
    CreditBalance: 5
};
